// apiService.js
import axios from 'axios';
import {apiService} from "./ApiService";
import {properties} from "../config/ClientConfigurations.js";

// const API_URL = 'http://localhost:3001'; // Replace with your actual API URL

export const fetchStoreData= async (pageIndex, pageSize) => {

    const token = apiService.getAccessToken();

    try {
        const response = await axios.get(`${properties.apiUrl}/api/v1/stores`, {
            headers: {
                Authorization: `Bearer ${token}`, // Add Bearer token to request headers
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

// Function to fetch data from the API
export const fetchStoreDataPaginated= async (pageIndex, pageSize) => {

    const token = apiService.getAccessToken();

    // Construct query parameters
    const params = new URLSearchParams({
        page: pageIndex, // You can adjust pagination if needed
        limit: pageSize, // Set your desired limit
    });

    try {
        const response = await axios.get(`${properties.apiUrl}/api/v1/stores-paginated?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Add Bearer token to request headers
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


